export const BASE_URL = '/app/dashboard';
export const BASE_URL_LOGIN = '/login';

export const CONFIG = {
  layout: 'vertical',
  collapseMenu: false,
  layoutType: 'menu-dark'
};
